/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventorySummaryResponse {
    getFixupPrototypeFunction() { return InventorySummaryResponse.fixupPrototype; }

    static newInstance(model: Partial<InventorySummaryResponse>): InventorySummaryResponse {
        let obj = Object.assign(new InventorySummaryResponse(), model);
        InventorySummaryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventorySummaryResponse>): InventorySummaryResponse {
        if (!model) return null;
        return InventorySummaryResponse.newInstance(<InventorySummaryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventorySummaryResponse) {
        if (!obj) return;

        models.InventorySummaryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventorySummaryResponse): boolean {
        Object.setPrototypeOf(obj, InventorySummaryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.summary) {
            for (let val of this.summary) {
                models.InventorySummaryByCategory.fixupPrototype(val);
            }
        }
    }

    /**
     * Service categories this provider holds inventory for, for example Compute or Storage, largest first
     */
    summary: Array<models.InventorySummaryByCategory>;

}
